import { useTheme } from "@emotion/react";
import { appLinkTreesObject } from "@megarax/links";

import { navAccent } from "../nav/navConstants";
import { isSignalGroupUnread, SignalDocumentGroup } from "./groupSignals";
import { SignalAppIcon } from "./SignalAppIcon";
import { SignalLabelsList } from "./SignalLabelsList";

type Props = {
  group: SignalDocumentGroup;
};

export const SignalDocumentPrimaryCell: React.FC<Props> = ({ group }) => {
  const theme = useTheme();
  const primarySignal = group.signals[0];
  const isUnread = isSignalGroupUnread(group);
  const appColor = appLinkTreesObject[primarySignal.app]?.color ?? navAccent;

  return (
    <div css={{ display: "flex", alignItems: "flex-start", gap: "0.75rem", minWidth: 0 }}>
      <SignalAppIcon app={primarySignal.app} isUnread={isUnread} />
      <div css={{ display: "flex", flexDirection: "column", gap: "0.125rem", minWidth: 0 }}>
        <span css={{ display: "flex", alignItems: "center", gap: "0.375rem", minWidth: 0 }}>
          <span
            css={{
              color: appColor,
              fontWeight: isUnread ? 700 : 500,
              wordBreak: "break-word",
            }}
          >
            {group.name}
          </span>
        </span>
        <SignalLabelsList group={group} color={theme.colors.default} readOpacity={0.85} />
      </div>
    </div>
  );
};
